import { render, staticRenderFns } from "./deduct-balance.vue?vue&type=template&id=82e33cd6&"
import script from "./deduct-balance.vue?vue&type=script&lang=js&"
export * from "./deduct-balance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports